<template>
    <div>
        <button class="mode-switcher__toggle" @click="visible = !visible" v-if="!visible">
            <svg width="777" height="681" viewBox="0 0 777 681" xmlns="http://www.w3.org/2000/svg"><path d="M209.662 0h357.68c11.007 0 21.212 5.857 26.67 15.414l178.872 309.688a30.917 30.917 0 0 1 0 30.826l-178.872 309.66C588.554 675.145 578.38 681 567.342 681h-357.68c-11.009 0-21.215-5.855-26.673-15.412L4.117 355.928a30.91 30.91 0 0 1 0-30.826L182.989 15.414C188.478 5.857 198.653 0 209.662 0zm178.839 155.585c-102.031 0-185.008 82.954-185.008 184.96 0 102.008 82.977 184.963 185.008 184.963 102.001 0 185.007-82.955 185.007-184.962 0-102.007-82.975-184.961-185.007-184.961z" fill="#FFF" fill-rule="nonzero"/></svg>
        </button>
        <div :class="['mode-switcher', visible ? 'visible' : '']">
            <transition name="mode-switcher-vignette-transition">
                <div v-show="visible" class="mode-switcher__vignette" @click="visible = false"></div>
            </transition>
            <transition name="mode-switcher-content-transition">
                <div class="mode-switcher__content" v-show="visible">
                    <button class="mode-switcher__close" @click="visible = false">
                        <i class="fa fa-times"></i>
                    </button>
                    <div class="mode-switcher__content__block">
                        <h3 class="mode-switcher__content__block__header large centered">Prototype preferences</h3>
                    </div>
                    <div class="mode-switcher__divider"></div>
                    <div class="mode-switcher__content__columns">
                        <div class="mode-switcher__content__columns__column">
                            <div class="mode-switcher__content__block">
                                <h3 class="mode-switcher__content__block__header">Preset</h3>
                                <select v-model="currentPreset" class="mode-switcher__select">
                                    <option v-for="preset in presets" :value="preset.value">
                                        {{ preset.label }}
                                    </option>
                                </select><br><br>
                                <a @click="advanced = !advanced">{{ advanced ? 'Hide advanced options' : 'Show advanced options' }}</a>
                            </div>
                            <div class="mode-switcher__content__block border-top" v-if="false">
                                <h3 class="mode-switcher__content__block__header">Demo</h3>
                                <iframe src="https://player.vimeo.com/video/208475715" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                            </div>
                        </div>
                        <div class="mode-switcher__content__columns__column" v-if="advanced">
                            <div class="mode-switcher__content__block">
                                <h3 class="mode-switcher__content__block__header">Choose universal navigation mode</h3>
                                <div class="mode-switcher__form-groups">
                                    <label class="mode-switcher__form-group" v-for="mode in availableModes">
                                        <div class="mode-switcher__form-group__radio">
                                            <input type="radio" name="mode" :checked="mode.key === currentMode" :value="mode.key" @change="() => onChangeMode(mode.key)" />
                                            <div class="mode-switcher__form-group__icon mode-switcher__form-group__icon__selected" v-if="mode.key === currentMode">
                                                <i :class="['fa', 'outer', 'fa-circle']"></i>
                                                <i :class="['fa', 'inner', 'fa-circle']"></i>
                                            </div>
                                            <i :class="['fa', 'mode-switcher__form-group__icon', 'fa-circle']" v-if="mode.key !== currentMode"></i>
                                        </div>
                                        <div class="mode-switcher__form-group__image large" v-if="mode.image && false">
                                            <img :src="mode.image" alt="" />
                                        </div>
                                        <div class="mode-switcher__form-group__content">
                                            <h4>{{ mode.label }}</h4>
                                            <p>{{ mode.description }}</p>
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="mode-switcher__content__block" v-if="false">
                                <h3 class="mode-switcher__content__block__header">Alt-key action</h3>
                                <div class="mode-switcher__form-groups">
                                    <label class="mode-switcher__form-group" v-for="mode in altClickModes">
                                        <div class="mode-switcher__form-group__radio">
                                            <input type="radio" name="mode" :checked="mode.key === currentAltClickMode" :value="mode.key" @change="() => onChangeAltClickMode(mode.key)" />
                                            <div class="mode-switcher__form-group__icon mode-switcher__form-group__icon__selected" v-if="mode.key === currentAltClickMode">
                                                <i :class="['fa', 'outer', 'fa-circle']"></i>
                                                <i :class="['fa', 'inner', 'fa-circle']"></i>
                                            </div>
                                            <i :class="['fa', 'mode-switcher__form-group__icon', 'fa-circle']" v-if="mode.key !== currentAltClickMode"></i>
                                        </div>
                                        <div class="mode-switcher__form-group__image large" v-if="mode.image && false">
                                            <img :src="mode.image" alt="" />
                                        </div>
                                        <div class="mode-switcher__form-group__content">
                                            <h4>{{ mode.label }}</h4>
                                            <p>{{ mode.description }}</p>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="mode-switcher__content__columns__column" v-if="advanced">
                            <div class="mode-switcher__content__block">
                                <h3 class="mode-switcher__content__block__header">Choose back button layout</h3>
                                <div class="mode-switcher__form-groups">
                                    <label class="mode-switcher__form-group" v-for="behavior in backButtonBehaviors">
                                        <div class="mode-switcher__form-group__radio">
                                            <input type="radio" name="mode" :checked="behavior.key === currentBackButtonBehavior" :value="behavior.key" @change="() => onChangeBackButtonBehavior(behavior.key)" />
                                            <div class="mode-switcher__form-group__icon mode-switcher__form-group__icon__selected" v-if="behavior.key === currentBackButtonBehavior">
                                                <i :class="['fa', 'outer', 'fa-circle']"></i>
                                                <i :class="['fa', 'inner', 'fa-circle']"></i>
                                            </div>
                                            <i :class="['fa', 'mode-switcher__form-group__icon', 'fa-circle']" v-if="behavior.key !== currentBackButtonBehavior"></i>
                                        </div>
                                        <div class="mode-switcher__form-group__image small" v-if="behavior.image && false">
                                            <img :src="behavior.image" alt="" />
                                        </div>
                                        <div class="mode-switcher__form-group__content">
                                            <h4>{{ behavior.label }}</h4>
                                            <p>{{ behavior.description }}</p>
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="mode-switcher__content__block border-top">
                                <h3 class="mode-switcher__content__block__header">Choose context switcher layout</h3>
                                <div class="mode-switcher__form-groups">
                                    <label class="mode-switcher__form-group" v-for="switcherLayout in switcherLayouts">
                                        <div class="mode-switcher__form-group__radio">
                                            <input type="radio" name="mode" :checked="switcherLayout.key === currentSwitcherLayout" :value="switcherLayout.key" @change="() => onChangeSwitcherLayout(switcherLayout.key)" />
                                            <div class="mode-switcher__form-group__icon mode-switcher__form-group__icon__selected" v-if="switcherLayout.key === currentSwitcherLayout">
                                                <i :class="['fa', 'outer', 'fa-circle']"></i>
                                                <i :class="['fa', 'inner', 'fa-circle']"></i>
                                            </div>
                                            <i :class="['fa', 'mode-switcher__form-group__icon', 'fa-circle']" v-if="switcherLayout.key !== currentBackButtonBehavior"></i>
                                        </div>
                                        <div class="mode-switcher__form-group__image small" v-if="switcherLayout.image">
                                            <img :src="switcherLayout.image" alt="" />
                                        </div>
                                        <div class="mode-switcher__form-group__content">
                                            <h4>{{ switcherLayout.label }}</h4>
                                            <p>{{ switcherLayout.description }}</p>
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="mode-switcher__content__block border-top">
                                <h3 class="mode-switcher__content__block__header">Choose "Show all" behavior"</h3>
                                <div class="mode-switcher__form-groups">
                                    <label class="mode-switcher__form-group" v-for="showAllBehavior in showAllBehaviors">
                                        <div class="mode-switcher__form-group__radio">
                                            <input type="radio" name="mode" :checked="showAllBehavior.key === currentShowAllBehavior" :value="showAllBehavior.key" @change="() => onChangeShowAllBehavior(showAllBehavior.key)" />
                                            <div class="mode-switcher__form-group__icon mode-switcher__form-group__icon__selected" v-if="showAllBehavior.key === currentShowAllBehavior">
                                                <i :class="['fa', 'outer', 'fa-circle']"></i>
                                                <i :class="['fa', 'inner', 'fa-circle']"></i>
                                            </div>
                                            <i :class="['fa', 'mode-switcher__form-group__icon', 'fa-circle']" v-if="showAllBehavior.key !== currentShowAllBehavior"></i>
                                        </div>
                                        <div class="mode-switcher__form-group__image small" v-if="showAllBehavior.image">
                                            <img :src="showAllBehavior.image" alt="" />
                                        </div>
                                        <div class="mode-switcher__form-group__content">
                                            <h4>{{ showAllBehavior.label }}</h4>
                                            <p>{{ showAllBehavior.description }}</p>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import keymaster from 'keymaster';

    export default {
        name: 'mode-switcher',
        mounted() {
            // Get persisted preset
            const preset = this.getPersistedValue('APP_PRESET');
            if (preset) {
                this.currentPreset = preset;
            } else {
                this.currentPreset = 1;
                this.savePreset(1);
            }

            // Add shortcut for debugger
            const key = keymaster;
            key.filter = () => true;
            key('m', () => {
                this.visible = !this.visible;
            });
            key('esc', () => {
                if (this.visible === true) {
                    this.visible = false;
                }
            });
        },
        data() {
            return {
                visible: false,
                advanced: false,
                currentPreset: 1,
                presets: [
                    {
                        label: 'Preset 1',
                        value: 1,
                    },
                    {
                        label: 'Preset 2',
                        value: 2,
                    },
                    {
                        label: 'Preset 3',
                        value: 3,
                    },
                    {
                        label: 'Preset 4',
                        value: 4,
                    },
                ]
            };
        },
        watch: {
            currentPreset(preset) {
                this.savePreset(preset);
            },
        },
        methods: {
            savePreset(preset) {
                this.setPreset(parseInt(preset, 10));
                this.persistValue('APP_PRESET', preset);
            },
            toggle() {
                this.visible = !this.visible;
            },
            persistValue(key, value) {
                if (typeof localStorage !== 'undefined' && value) {
                    localStorage.setItem(key, value);
                }
            },
            getPersistedValue(key) {
                if (typeof localStorage === 'undefined') {
                    return false;
                }

                return localStorage.getItem(key);
            },
            setPreset(number) {
                const { onChangeMode, onChangeSwitcherLayout, onChangeBackButtonBehavior, onChangeShowAllBehavior } = this;
                // Preset 1 (mode: A, boxes, back, home with search)
                // Preset 2 (mode: B, boxes, back, full list)
                // Preset 3 (mode: C, boxes, back, home with search)
                // Preset 4 (mode: C, tabs, back button, home with search)
                switch (number) {
                    case 1:
                        onChangeMode('OWNER_APP_CLEAR');
                        onChangeSwitcherLayout('boxes');
                        onChangeBackButtonBehavior('dont_show');
                        onChangeShowAllBehavior('owner_home');
                    break;
                    case 2:
                        onChangeMode('SAME_APP_ADD');
                        onChangeSwitcherLayout('boxes');
                        onChangeBackButtonBehavior('show_back');
                        onChangeShowAllBehavior('full_list');
                    break;
                    case 3:
                        onChangeMode('OWNER_APP_NEW_CONTEXT');
                        onChangeSwitcherLayout('boxes');
                        onChangeBackButtonBehavior('dont_show');
                        onChangeShowAllBehavior('owner_home');
                    break;
                    case 4:
                        onChangeMode('OWNER_APP_NEW_CONTEXT');
                        onChangeSwitcherLayout('tabs');
                        onChangeBackButtonBehavior('show_back');
                        onChangeShowAllBehavior('owner_home');
                    break;
                }
            }
        },
        props: ['currentMode', 'availableModes', 'onChangeMode', 'backButtonBehaviors', 'currentBackButtonBehavior', 'onChangeBackButtonBehavior', 'switcherLayouts', 'currentSwitcherLayout', 'onChangeSwitcherLayout', 'currentShowAllBehavior', 'showAllBehaviors', 'onChangeShowAllBehavior', 'currentAltClickMode', 'altClickModes', 'onChangeAltClickMode'],
    };
</script>

<style>
    .mode-switcher__toggle {
        height: 42px;
        width: 42px;
        border-radius: 999px;
        background-color: rgba(0, 0, 0, .8);
        position: fixed;
        bottom: 5px;
        left: 5px;
        opacity: .3;
        transition: opacity .1s;
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .mode-switcher__toggle svg {
        width: 20px;
        height: 20px;
    }

    .mode-switcher__toggle:hover {
        opacity: 1;
        transition: opacity .2s;
    }

    .mode-switcher.visible {
        z-index: 999;
    }

    .mode-switcher {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        font-size: 15px;
    }

    .mode-switcher a {
        font-size: .9em;
    }

    .mode-switcher a:hover {
        cursor: pointer;
        opacity: .8;
    }

    .mode-switcher__vignette {
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 999;
        position: absolute;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, .3);
    }

    .mode-switcher__divider {
        height: 1px;
        background-color: rgba(255, 255, 255, .08);
        width: 100%;
    }

    .mode-switcher__content {
        background-color: rgba(0, 0, 0, .8);
        color: #FFF;
        height: auto;
        border-radius: 10px;
        position: absolute;
        z-index: 1000;
        bottom: 20px;
        left: 20px;
        margin-right: 20px;
        min-width: 600px;
    }

    .mode-switcher__close {
        color: #FFF;
        position: absolute;
        right: 24px;
        top: 24px;
        font-size: 1.4em;
    }

    .mode-switcher__close:hover {
        cursor: pointer;
        opacity: .8;
    }

    .mode-switcher__content .mode-switcher__content__block:first-child {
        margin-top: 0;
    }

    .mode-switcher__content__block {
        padding: 30px;
    }

    .mode-switcher__content__block.border-top {
        border-top: 1px solid rgba(255, 255, 255, .1);
    }

    .mode-switcher__content__block iframe {
        width: 30vw;
        height: 18vw;
    }

    .mode-switcher__form-group {
        display: flex;
        cursor: pointer;
        margin-top: 14px;
        align-items: flex-start;
    }

    .mode-switcher__content__columns .mode-switcher__content__columns__column {
        border-right: 1px solid rgba(255, 255, 255, .1);
    }

    .mode-switcher__content__columns .mode-switcher__content__columns__column:last-child {
        border-right: 0;
    }

    .mode-switcher__content__columns {
        display: flex;
    }

    .mode-switcher__form-group__content {
        flex: auto;
    }

    .mode-switcher__form-group__content p {
        color: rgba(255, 255, 255, .6);
        line-height: 130%;
        font-size: 0.9em;
        margin-top: 2px;
    }

    .mode-switcher__form-group__image img {
        width: 100%;
    }

    .mode-switcher__form-group__image {
        margin-right: 16px;
    }

    .mode-switcher__form-group__image.large {
        width: 80px;
        flex: 0 0 80px;
    }

    .mode-switcher__form-group__image.small {
        width: 20px;
        flex: 0 0 20px;
    }

    .mode-switcher__form-group:hover {
        opacity: .9;
    }

    .mode-switcher__content__block__header.centered {
        text-align: center;
    }

    .mode-switcher__content__block__header {
        font-size: 1.1em;
        line-height: 100%;
    }

    .mode-switcher__content__block__header.large {
        font-size: 1.3em;
    }

    .mode-switcher__form-group__icon {
        font-size: 19px;
    }

    .mode-switcher__form-group__icon__selected {
        position: relative;
    }

    .mode-switcher__form-group__icon__selected .inner {
        color: #2b75bb;
        position: absolute;
        font-size: 10px;
        top: 4px;
        left: 4px;
    }

    .mode-switcher__form-group__icon__selected .outer {
        position: absolute;
    }

    .mode-switcher__form-groups {
        display: flex;
        flex-direction: column;
    }

    .mode-switcher__form-groups, .mode-switcher__content__block iframe {
        margin-top: 18px;
        min-width: 310px;
    }

    .mode-switcher__form-group input {
        position: absolute;
        left: -9999px;
    }

    .mode-switcher__form-group__radio {
        width: 30px;
        /*padding-top: 2px;*/
    }

    .mode-switcher-vignette-transition-enter-to,
    .mode-switcher-vignette-transition-leave {
        opacity:1;
        transition:opacity .5s;
    }
    .mode-switcher-vignette-transition-enter,
    .mode-switcher-vignette-transition-leave-to {
        opacity:0;
        transition:opacity .2s;
    }

    .mode-switcher-content-transition-enter-to,
    .mode-switcher-content-transition-leave {
        opacity:1;
        transition: all .2s;
        transform:translatey(0);
    }
    .mode-switcher-content-transition-enter,
    .mode-switcher-content-transition-leave-to {
        opacity:0;
        transition: all .2s;
        transform:translatey(-27px);
    }

    .mode-switcher__select {
        margin-top: 10px;
        width: 300px;
        font-size: 20px;
    }
</style>



// WEBPACK FOOTER //
// index.vue?54ac0ff8